import * as React from "react";
const SvgFiRrMugTea = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mug-tea_svg__a)">
      <path
        fill="#062147"
        d="M20.552 12.139C21.15 9.563 21.6 6.247 18 6H9.01c-.018-.009-5.987.008-6.01 0a3.04 3.04 0 0 0-2.245.981 2.93 2.93 0 0 0-.747 2.28 31.9 31.9 0 0 0 3.136 10.805A6.98 6.98 0 0 0 9.437 24h2.127a6.96 6.96 0 0 0 5.736-3H19c5.091.162 7.377-7.84 1.552-8.861m-12.258.982L9 12.414c.316.363 1.055.86 1 1.415V15.5a.5.5 0 0 1-.5.5c-.43-.046-1.508.219-1.5-.5.061-.533-.2-1.991.294-2.379M11.564 22H9.437a4.99 4.99 0 0 1-4.5-2.817A29.9 29.9 0 0 1 2 9.067.972.972 0 0 1 3 8h5v2.585c-.872.857-2.1 1.887-2 3.243V15.5A2.5 2.5 0 0 0 8.5 18h1a2.5 2.5 0 0 0 2.5-2.5v-1.671c.1-1.353-1.127-2.39-2-3.243V8h8a1.01 1.01 0 0 1 .763.326.95.95 0 0 1 .238.74 29.9 29.9 0 0 1-2.936 10.114 4.99 4.99 0 0 1-4.5 2.82M19 19h-.643a33 33 0 0 0 1.743-4.91c1.891.325 1.9 1.457 1.9 1.91a3 3 0 0 1-3 3M9.026 3V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0m4 0V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0m-8 0V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mug-tea_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMugTea;
